import * as React from 'react';
export const CNSvg = React.forwardRef(function CNSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#E25950',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M7 1.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm0 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm-1 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM3.471 5.963 1.715 6.971l.435-1.969L.971 3.525l1.772-.098L3.47 1.9l.73 1.527 1.77.098-1.179 1.477.492 1.97-1.813-1.01Z',
      }),
    ),
  );
});
CNSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CN = {
  category: 'flag',
  colorable: false,
  name: 'CN',
  svg: CNSvg,
};
